import React from 'react'
import * as f from '../../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    DataTransformer,
    NullClickStrategy,
    OnlyFilterActionDisplayStrategy,
    TableFieldDescription,
    StatusChipComponentCreator,
    DateTimeComponentCreator,
    DateTimeDisplayCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import { GraphQLDownloadFile } from '../../../components/FileDownloader/FileComponentDownloader'
import { ExportFooterItemCreator } from '../../../components/BPMTable/TableFooterItems'
import { checkProcessDuration } from '../../../utils/processControlUtils'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


const queries = {tableQueryBuilder: new DirectTableQueryBuilder('myMassiveLoadTemplates')};


class DataLoadTemplatesTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "DataLoadTemplatesTableCreator"
    }

    getTableCreator = (tableName) => {
            
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, queries, 
                                                    new NullClickStrategy(), new OnlyFilterActionDisplayStrategy())

        tableCreator.setAdditionalFilters({first: 30})
        tableCreator.setInitialSortField('createdAt', 'desc')
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);

        tableCreator.setDescriptions([
            new TableFieldDescription(
                'user',
                new DataMapper("user.email"),
                new f.FilterDescription(new f.TextFilter("user")),
                {label: 'User', onlyForm: true}
            ),
            new TableFieldDescription(
                'modelName',
                new DataMapper("modelName"),
                new f.FilterDescription(new f.TextFilter('modelName')),
                {label: 'Model Name'}
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.PeriodFilter("createdAt")),
                {label: 'Creation Date', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator()}
            ),
            new TableFieldDescription(
                'duration',
                new DataMapper("duration", "createdAt", "updatedAt", "state"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Duration', transform: new DataTransformer(({duration, createdAt, updatedAt, state}) => checkProcessDuration(duration, createdAt, updatedAt, state))}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.ProcessControlStateFilter("state")),
                {label: 'Status', componentCreator: new StatusChipComponentCreator()}
            ),
            new TableFieldDescription(
                'downloadFile',
                new DataMapper("id", "hasFile"),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'File',
                    hideSort: true,
                    transform: new DataTransformer(({id, hasFile}) =>
                        hasFile ? <GraphQLDownloadFile resourceType='data_template' id={id} /> : null
                    ),
                }
            ),
        ])
 
        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(DataLoadTemplatesTableCreator)

export default DataLoadTemplatesTableCreator;
